import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettings } from '../shared/appsettings';
import { LookupValue, State, ApiResponse, MemberService } from "@affinite/common";
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Procedure } from '../models/Lookups/procedure';
import { Diagnosis } from '../models/Lookups/diagnosis';
import { Provider } from '../models/Lookups/provider';
import { map } from "rxjs/operators";
import { PROVIDER_TYPE, TASKSTATUS_PENDING, TASKSTATUS_SUCCESSFUL, TASKSTATUS_UNSUCCESSFUL } from '../../assets/constants';
import { ConfigService } from './config-service.service';
import { AuthIntakeForm } from '../models/authForm/authIntakeForm';
import Swal from 'sweetalert2';
import { DueDateRuleChangeStatus } from '../models/Lookups/dueDateRuleChangeStatus';
import { LookupSet } from '../models/Lookups/lookupSet';

@Injectable({
  providedIn: 'root'
})
export class LookupService {
  private lookupServiceBaseUrl!: string;

  private lookupDataSet = new BehaviorSubject<LookupValue[]>([]);
  LookupData = this.lookupDataSet.asObservable(); 
  private procList = new BehaviorSubject<Procedure[]>([]);
  ProcedureList = this.procList.asObservable();

  private diagList = new BehaviorSubject<Diagnosis[]>([]);
  DiagnosisList = this.diagList.asObservable();

  private provList = new BehaviorSubject<Provider[]>([]);
  ProviderList = this.provList.asObservable();

  private selectedProvList = new BehaviorSubject<Provider[]>([]);
  selectedProviderList = this.selectedProvList.asObservable();

  public TaskSuccessIds: number[] = [];
  public TaskUnsuccessfulIds: number[] = [];
  public TaskPendingIds = new Subject<number[]>();
  private baseLookupSet: LookupValue[] = [];
  public ReqProviderTemp = new BehaviorSubject<boolean>(false);
  public SvcProviderTemp = new BehaviorSubject<boolean>(false);
  public selectedReqProvider: Provider | null = null;
  public selectedSvcProvider: Provider | null = null;

  public AuthTypes = new BehaviorSubject<LookupValue[]>([]);
  public AuthRequestOrigin = new BehaviorSubject<LookupValue[]>([]);
  public RequestorTypes = new BehaviorSubject<LookupValue[]>([]);
  public RequestTypes = new BehaviorSubject<LookupValue[]>([]);
  public UrgencyTypes = new BehaviorSubject<LookupValue[]>([]);
  public DecisionStatusTypes = new BehaviorSubject<LookupValue[]>([]);
  public DecisionStatusReasonTypes = new BehaviorSubject<LookupValue[]>([]);
  public LineItemStatusTypes = new BehaviorSubject<LookupValue[]>([]);
  public LineItemStatusReasonTypes = new BehaviorSubject<LookupValue[]>([]);
  public TreatmentTypes = new BehaviorSubject<LookupValue[]>([]);
  public TATUnitTypes = new BehaviorSubject<LookupValue[]>([]);
  public TATStatus = new BehaviorSubject<LookupValue[]>([]);
  public TATStatusList = new BehaviorSubject<DueDateRuleChangeStatus[]>([]);

  public LookupSet: LookupSet[] = [];
  public AllLookupValues: LookupValue[]=[];

  constructor(private http: HttpClient, 
      private config: AppSettings, 
      private configService: ConfigService
  ) {
    this.lookupServiceBaseUrl = config.lookupServiceBaseUrl;
  }

  public getLookupValueId(lookupStandardValue:string, lookupSetId: number|undefined=undefined):number|null{
    var lookupId = undefined;
    if (lookupSetId){
      lookupId = this.lookupDataSet.value.find(l => l.lookupStandardValue.toLowerCase() == lookupStandardValue.toLowerCase() && l.lookupSetID == lookupSetId);
    } else {
      lookupId = this.lookupDataSet.value.find(l => l.lookupStandardValue.toLowerCase() == lookupStandardValue.toLowerCase());
    }

    if (lookupId){
      return lookupId.lookupValueID;
    }
    return null;
  }

  searchProvidersLive(searchString: string, skip: number) {
    let lookupUrl = this.lookupServiceBaseUrl + "LookupClientFeed/SearchProviders";
    let queryParams = new HttpParams();
    queryParams = queryParams.append("skip", skip*100);
    queryParams = queryParams.append("take", 100);
    queryParams = queryParams.append("searchBy", searchString)
    return this.http.get<ApiResponse<Provider[]>>(lookupUrl, { params: queryParams });//.subscribe(data => {
  }

  searchProcedures(searchString: string) {
    let lookupUrl = this.lookupServiceBaseUrl + "LookupClientFeed/GetProcedures";
    let queryParams = new HttpParams();
    queryParams = queryParams.append("skip", 0);
    queryParams = queryParams.append("take", 100);
    queryParams = queryParams.append("searchBy", searchString)
    return this.http.get<ApiResponse<Procedure[]>>(lookupUrl, { params: queryParams });//.subscribe(data => {
  }

  getProcedures(procedures: string[]) {
    let lookupUrl = this.lookupServiceBaseUrl + "LookupClientFeed/GetProceduresByCode";
    let queryParams = new HttpParams();
    queryParams = queryParams.append("procedureCode", procedures.toString())
    return this.http.get<ApiResponse<Procedure[]>>(lookupUrl, { params: queryParams });//.subscribe(data => {
  }

  searchDiagnosis(searchString: string) {
    let lookupUrl = this.lookupServiceBaseUrl + "LookupClientFeed/GetDiagnosis";
    let queryParams = new HttpParams();
    queryParams = queryParams.append("skip", 0);
    queryParams = queryParams.append("take", 100);
    queryParams = queryParams.append("searchBy", searchString)
    return this.http.get<ApiResponse<Diagnosis[]>>(lookupUrl, { params: queryParams });//.subscribe(data => {
  }

  populateSelectedProviders(authForm: AuthIntakeForm) {
    let selectedProviders: Provider[] = [];
    if (authForm.authIntakeHeader.reqFinalProviderHashId) {
      this.getProviderByHashId(authForm.authIntakeHeader.reqFinalProviderHashId, authForm.authIntakeDetail[0].authDetailId, PROVIDER_TYPE.REQUESTING).subscribe((res) => {
        if (res.succeeded && res.data) {
          let type = this.lookupDataSet.value.filter(t => t.lookupValueID == 10041)[0]?.lookupStandardLabel;
          this.ReqProviderTemp.next(res.data.isTempProvider);
          res.data.type = type;
          selectedProviders.push(res.data);
          this.selectedReqProvider = res.data;
          if (res.data.providerInfoChanged){
            authForm.authIntakeHeader.reqFinalProviderHashId = res.data.hashId;
            Swal.fire({
              title: 'Requesting Provider Updated',
              text: `Requesting Provider Information has been updated. Please verify the correct provider is selected.`,
              icon: 'info', //possible values - error/success/info/question
              allowOutsideClick: false,
              showCancelButton: false,
              confirmButtonColor: '#5890a3',
              confirmButtonText: 'OK'
            });
          }
          this.selectedProvList.next(selectedProviders);

        } else if (res.succeeded && !res.data) { //The provider info has updated and the hashId no longer exists. We cannot retrieve provider info reliably. Display message for user to select provider again
          Swal.fire({
            title: 'Provider Not Found',
            text: `Requesting provider not found. Please search for provider again using NPI ${authForm.authIntakeHeader.reqNPI}`,
            icon: 'error', //possible values - error/success/info/question
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonColor: '#5890a3',
            confirmButtonText: 'OK'
          });
        }
      });
    }
    else if (authForm.authIntakeHeader.reqNPI && authForm.authIntakeHeader.reqNPI) {
      this.getProviderByProviderInfo(authForm.authIntakeHeader.reqNPI, authForm.authIntakeHeader.reqServiceLocationID,authForm.authIntakeDetail[0].authDetailId).subscribe((res) => {
        if (res.succeeded && res.data && res.data.length > 0) {
          let type = this.lookupDataSet.value.filter(t => t.lookupValueID == 10041)[0]?.lookupStandardLabel;
          let uniqueProvider = res.data.find(p => p.hashId == authForm.authIntakeHeader.reqFinalProviderHashId);
          if (uniqueProvider) {
            uniqueProvider.type = type;
            selectedProviders.push(uniqueProvider);
            this.selectedReqProvider = uniqueProvider;
          } else {
            res.data[0].type = type;
            selectedProviders.push(res.data[0]);
            this.selectedReqProvider = res.data[0];
          }
          this.selectedProvList.next(selectedProviders);
        }
      });
    }
    if (authForm.authIntakeHeader.srvcFinalProviderHashId) {
      this.getProviderByHashId(authForm.authIntakeHeader.srvcFinalProviderHashId, authForm.authIntakeDetail[0].authDetailId, PROVIDER_TYPE.SERVICING).subscribe((res) => {
        if (res.succeeded && res.data) { 
          let type = this.lookupDataSet.value.filter(t => t.lookupValueID == 10042)[0]?.lookupStandardLabel;
          res.data.type = type;
          this.SvcProviderTemp.next(res.data.isTempProvider);
          selectedProviders.push(res.data);
          this.selectedSvcProvider = res.data;
          if (res.data.providerInfoChanged){
            authForm.authIntakeHeader.srvcFinalProviderHashId = res.data.hashId;
            Swal.fire({
              title: 'Servicing Provider Updated',
              text: `Servicing Provider Information has been updated. Please verify the correct provider is selected.`,
              icon: 'info', //possible values - error/success/info/question
              allowOutsideClick: false,
              showCancelButton: false,
              confirmButtonColor: '#5890a3',
              confirmButtonText: 'OK'
            });
          }
          this.selectedProvList.next(selectedProviders);
        } else if (res.succeeded && !res.data) { //The provider info has updated and the hashId no longer exists. We cannot retrieve provider info reliably. Display message for user to select provider again
          Swal.fire({
            title: 'Provider Not Found',
            text: `Servicing provider not found. Please search for provider again using NPI ${authForm.authIntakeHeader.srvcNPI}`,
            icon: 'error', //possible values - error/success/info/question
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonColor: '#5890a3',
            confirmButtonText: 'OK'
          });
        }
      });
    }
    else if (authForm.authIntakeHeader.srvcNPI && authForm.authIntakeHeader.srvcNPI) {
      this.getProviderByProviderInfo(authForm.authIntakeHeader.srvcNPI, authForm.authIntakeHeader.srvcServiceLocationID,authForm.authIntakeDetail[0].authDetailId).subscribe((res) => {
        if (res.succeeded && res.data && res.data.length > 0) { 
          let type = this.lookupDataSet.value.filter(t => t.lookupValueID == 10042)[0]?.lookupStandardLabel;
          let uniqueProvider = res.data.find(p => p.hashId == authForm.authIntakeHeader.srvcFinalProviderHashId);
          if (uniqueProvider) {
            uniqueProvider.type = type;
            selectedProviders.push(uniqueProvider);
            this.selectedSvcProvider = uniqueProvider;
          } else {
            res.data[0].type = type;
            selectedProviders.push(res.data[0]);
            this.selectedSvcProvider = res.data[0];
          }
          this.selectedProvList.next(selectedProviders);

        }
      });
    }
    if (authForm.authIntakeOtherProviders && authForm.authIntakeOtherProviders.length > 0) {
      authForm.authIntakeOtherProviders.forEach(p => {
        if (p.finalProviderHashId && p.obsolete === false) {
          this.getProviderByHashId(p.finalProviderHashId,authForm.authIntakeDetail[0].authDetailId,PROVIDER_TYPE.OTHER).subscribe((res) => {
            if (res.succeeded && res.data) {
              let type = this.lookupDataSet.value.filter(t => t.lookupValueID == p.providerTypeId)[0]?.lookupStandardLabel;

              res.data.type = type;
              selectedProviders.push(res.data);
            }
            this.selectedProvList.next(selectedProviders);

          });
        }
      })
    }
    else if (authForm.authIntakeOtherProviders !== undefined && authForm.authIntakeOtherProviders.length > 0) {
      authForm.authIntakeOtherProviders.forEach(p => {
        if (p.npi && p.obsolete === false) {
          this.getProviderByProviderInfo(p.npi, p.serviceLocationID,p.authDetailId).subscribe((res) => {
            if (res.succeeded && res.data && res.data.length > 0) {
              let type = this.lookupDataSet.value.filter(t => t.lookupValueID == p.providerTypeId)[0]?.lookupStandardLabel;
              let uniqueProvider = res.data.find(r => r.hashId == p.finalProviderHashId);
              if (uniqueProvider) {
                uniqueProvider.type = type;
                selectedProviders.push(uniqueProvider);
              } else {
                res.data[0].type = type;
                selectedProviders.push(res.data[0]);
              }
                  this.selectedProvList.next(selectedProviders);
            }
          });
        }
      })
    }
    this.selectedProvList.next(selectedProviders);
  }

  getProviderByProviderInfo(npi: string | null, serviceLocationID: string | null, authDetailId: number | null) {
    let lookupUrl = this.lookupServiceBaseUrl + "LookupClientFeed/GetProvidersByProviderInfo";
    let queryParams = new HttpParams();
    queryParams = queryParams.append("npi", npi??'');
    queryParams = queryParams.append("serviceLocationID", serviceLocationID??'');
    queryParams = queryParams.append("authDetailId", authDetailId??'');

    return this.http.get<ApiResponse<Provider[]>>(lookupUrl, { params: queryParams });
  }

  getProviderByHashId(hashId: string, authDetailId: number, providerType: PROVIDER_TYPE) {
    let lookupUrl = this.lookupServiceBaseUrl + "LookupClientFeed/GetProviderByHashID";
    let queryParams = new HttpParams();
    queryParams = queryParams.append("hashID", hashId);
    queryParams = queryParams.append("authDetailId", authDetailId??0);
    queryParams = queryParams.append("providerType", providerType);

    return this.http.get<ApiResponse<Provider>>(lookupUrl, { params: queryParams });
  }

  validateProviderNPI(npi: string) {
    let lookupUrl = this.lookupServiceBaseUrl + "LookupClientFeed/ValidateProviderNPI";
    let queryParams = new HttpParams();
    queryParams = queryParams.append("npi", npi.trim());

    return this.http.get<ApiResponse<string>>(lookupUrl, { params: queryParams });
  }

  getProcedureCodes(): void {
    let lookupUrl = this.lookupServiceBaseUrl + "LookupClientFeed/GetProcedures";
    this.http.get<ApiResponse<Procedure[]>>(lookupUrl).subscribe(
      data => {
        if (data.succeeded == true) {
          this.procList.next(data.data!);
          console.log("GetProcedures");
        }
      }
    );
  }

  getDiagnosisCodes(): void {
    let lookupUrl = this.lookupServiceBaseUrl + "LookupClientFeed/GetDiagnosis";
    this.http.get<ApiResponse<Diagnosis[]>>(lookupUrl).subscribe(
      data => {
        if (data.succeeded == true) {
          this.diagList.next(data.data!);
        }
      }
    );
  }

  getAllLookupValues(forceRefresh:boolean=false) {
    let headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json'
    });

    let queryParams = new HttpParams();
    queryParams = queryParams.append("customerId", this.config.customerId);
    queryParams = queryParams.append("productId", 5);
    queryParams = queryParams.append("forceRefresh", forceRefresh);
    let lookupUrl = this.lookupServiceBaseUrl + "LookupValue/GetActiveLookupValuesByCustomerProduct";
    let options = { headers: headers, params: queryParams };
    this.http.get<ApiResponse<LookupValue[]>>(lookupUrl, options).subscribe(l => {
      if (l && l.succeeded && l.data) {
        this.baseLookupSet = l.data;
        this.lookupDataSet.next(l.data!);
        this.TaskSuccessIds = l.data.filter(t => t.lookupStandardValue.toLowerCase() === TASKSTATUS_SUCCESSFUL.toLowerCase()).map(o => o.lookupValueID);
        this.TaskUnsuccessfulIds = l.data.filter(t => t.lookupStandardValue.toLowerCase() === TASKSTATUS_UNSUCCESSFUL.toLowerCase()).map(o => o.lookupValueID);
        this.TaskPendingIds.next(l.data.filter(t => t.lookupStandardValue.toLowerCase() === TASKSTATUS_PENDING.toLowerCase()).map(o => o.lookupValueID));
        this.AuthTypes.next(l.data.filter(lookup => lookup.lookupSetID == 108 && lookup.isActive));
        this.AuthRequestOrigin.next(l.data.filter(lookup => lookup.lookupSetID == 111 && lookup.isActive));
        this.RequestorTypes.next(l.data.filter(lookup => lookup.lookupSetID == 114 && lookup.isActive));
        this.RequestTypes.next(l.data.filter(lookup => lookup.lookupSetID == 112 && lookup.isActive));
        this.UrgencyTypes.next(l.data.filter(lookup => lookup.lookupSetID == 109 && lookup.isActive));
        this.DecisionStatusTypes.next(l.data.filter(lookup => lookup.lookupSetID == 116 && lookup.isActive));
        this.DecisionStatusReasonTypes.next(l.data.filter(lookup => lookup.lookupSetID == 128 && lookup.isActive));
        this.LineItemStatusTypes.next(l.data.filter(lookup => lookup.lookupSetID == 122 && lookup.isActive));
        this.LineItemStatusReasonTypes.next(l.data.filter(lookup => lookup.lookupSetID == 129 && lookup.isActive));
        this.TreatmentTypes.next(l.data.filter(lookup => lookup.lookupSetID == 110 && lookup.isActive));
        this.TATUnitTypes.next(l.data.filter(lookup => lookup.lookupSetID == 151 && lookup.isActive));
      }
    });
    //Following code is to filter the lookup values based on the LOB/Entity associations.
    this.configService.lookupValueConfig.subscribe(c => {
      if (c && c.length > 0) {
        //Get a list of all lookup values that have an LOB configuration
        const lookupGuids = new Set(c.map(({ lookupValueGUID }) => lookupValueGUID));
        const refData = [...this.baseLookupSet];
        //Subset of lookup values from main table that only contain LOB configuration
        const data = Array.from(new Set(refData.filter(({ lookupValue_GUID }) => lookupGuids.has(lookupValue_GUID))));
        //Copy of the lookup values without any other filters.
        let allData = Array.from(new Set(refData));
        data.forEach(f => {
          allData = allData.filter(a => {
            return a.lookupSetID !== f.lookupSetID || a.lookupValue_GUID !== f.lookupValue_GUID;
          });
        })
        const finalData = [...allData, ...data];
        this.lookupDataSet.next(finalData);
        this.TaskSuccessIds = finalData.filter(t => t.lookupStandardValue.toLowerCase() === TASKSTATUS_SUCCESSFUL.toLowerCase()).map(o => o.lookupValueID);
        this.TaskUnsuccessfulIds = finalData.filter(t => t.lookupStandardValue.toLowerCase() === TASKSTATUS_UNSUCCESSFUL.toLowerCase()).map(o => o.lookupValueID);
        this.TaskPendingIds.next(finalData.filter(t => t.lookupStandardValue.toLowerCase() === TASKSTATUS_PENDING.toLowerCase()).map(o => o.lookupValueID));
      }
    })
  }

  getTATStatusList(): void {
    let lookupUrl = this.lookupServiceBaseUrl + "LookupValue/GetTATStatus";
    this.http.get<ApiResponse<DueDateRuleChangeStatus[]>>(lookupUrl).subscribe(
      data => {
        if (data.succeeded == true) {
          this.TATStatusList.next(data.data!);
        }
      }
    );
  }

  getLookupSets():Observable<LookupSet[]|void> {
    let headers = new HttpHeaders({ 'x-api-version': '1.0' });
    
    let lookupUrl = this.lookupServiceBaseUrl + "LookupSet/GetLookupSets";
    let options = { headers: headers };

    return this.http.get<ApiResponse<LookupSet[]>>(lookupUrl, options).pipe(
        map((data)=>{
          console.log("GetLookupSets");
          if (data.data){
            this.LookupSet = data.data;
          }
          return data.data;
        })
    );
  }

  getLookupSetByValue(lookupSetName: string): LookupSet|undefined {
    if (this.LookupSet){
      return this.LookupSet.find(l => l.lookupSetName.toLowerCase() == lookupSetName.toLowerCase());
    } else {
      this.getLookupSets().subscribe(d => {
        if (d) {
          return this.LookupSet.find(l => l.lookupSetName.toLowerCase() == lookupSetName.toLowerCase());
        }
        return undefined;
      })
    }
    return undefined;
  }

  getLookupValueBySet(lookupSetName: string):LookupValue[] {
    var lookupSet = this.getLookupSetByValue(lookupSetName);
    if (lookupSet && lookupSet.lookupSetID) {
      return this.lookupDataSet.value.filter(l => l.lookupSetID == lookupSet?.lookupSetID);
    }
    return [];
  }

  getAllLookups():Observable<LookupValue[]|void> {
    let headers = new HttpHeaders({ 'x-api-version': '1.0' });
    
    let lookupUrl = this.lookupServiceBaseUrl + "LookupValue/GetLookupValues";
    let options = { headers: headers };

    return this.http.get<ApiResponse<LookupValue[]>>(lookupUrl, options).pipe(
        map((data)=>{
          if (data.data){
            this.AllLookupValues = data.data;
          }
          return data.data;
        })
    );
  }
}
